// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Montserrat_5c8e8f', '__Montserrat_Fallback_5c8e8f'","fontStyle":"normal"},"className":"__className_5c8e8f"};